import api from "./api";

export interface IAMensagem {
  role: "user" | "assistant" | "system" | "tool";
  content: string;
  tool_call_id?: string;
  tool_calls?: any[];
  name?: string;
}

export interface IASettings {
  baseUrl?: string;
  apiKey?: string;
  model?: string;
}

export interface IAChatResposta {
  reply: string;
  toolCalls: Array<{ name: string; args: any; ok: boolean; error?: string; result?: any }>;
}

export async function iaChat(messages: IAMensagem[], settings?: IASettings) {
  const r = await api.post("/ia/chat", { messages, settings }, { timeout: 120000 });
  return r.data.data as IAChatResposta;
}

export async function iaHealthcheck(settings?: IASettings) {
  const params = new URLSearchParams();
  if (settings?.baseUrl) params.append("baseUrl", settings.baseUrl);
  if (settings?.apiKey) params.append("apiKey", settings.apiKey);
  const r = await api.get(`/ia/healthcheck?${params.toString()}`);
  return r.data.data as { ok: boolean; status?: number; baseUrl: string; erro?: string };
}

const KEY = "growsoft_ia_settings";

export function loadIASettings(): IASettings {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
}

export function saveIASettings(s: IASettings) {
  try { localStorage.setItem(KEY, JSON.stringify(s)); } catch {}
}
